<template>
    <button type="button" v-on:click="preview" v-bind:title="trans('Preview effect')" class="cu-p">
        <svg class="icon i-size-tiny c-muted" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path fill="currentColor" d="M12 0c6.617 0 12 5.383 12 12s-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0zm4.555 12.832a1.001 1.001 0 0 0-.001-1.664l-6-4A1 1 0 0 0 9 8v8a1 1 0 0 0 1.555.832l6-4z" class="icon" fill-rule="evenodd"/></svg>
    </button>
</template>
<script>
import confetti from 'canvas-confetti';

export default {
    props: {
        fieldName: {
            type: String,
            required: true,
        },
    },
    methods: {
        preview() {
            const select = document.querySelector(`select[name="${this.fieldName}"]`);
            const effect = select ? select.value : 'confetti';

            this.runEffect(effect);
        },
        runEffect(effect) {
            switch (effect) {
                case 'fireworks':
                    this.runFireworks();
                    break;
                case 'stars':
                    this.runStars();
                    break;
                case 'hearts':
                    this.runHearts();
                    break;
                default:
                    this.runConfetti();
            }
        },
        runConfetti() {
            confetti({
                particleCount: 400,
                spread: 360,
            });
        },
        runFireworks() {
            const end = Date.now() + 3000;
            const interval = setInterval(() => {
                if (Date.now() > end) {
                    clearInterval(interval);
                    return;
                }

                confetti({
                    startVelocity: 30,
                    spread: 360,
                    ticks: 60,
                    particleCount: 80,
                    origin: {
                        x: Math.random(),
                        y: Math.random() - 0.2,
                    },
                });
            }, 250);
        },
        runStars() {
            const star = confetti.shapeFromText({ text: "⭐", scalar: 2 });

            confetti({
                particleCount: 300,
                spread: 360,
                shapes: [star],
                scalar: 2,
            });
        },
        runHearts() {
            const heart = confetti.shapeFromText({ text: "❤️", scalar: 2 });

            confetti({
                particleCount: 300,
                spread: 360,
                shapes: [heart],
                scalar: 2,
            });
        },
    },
}
</script>
